import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import LinkOffIcon from "@material-ui/icons/LinkOff";

const useStyles = makeStyles(() => ({
  chip: {
    height: 20,
    fontSize: 10,
  },
  icon: {
    fontSize: 14,
  },
}));

/**
 * Selo de apólice sem contato acionável, usado no Kanban, nas listagens de
 * oportunidade e na Recuperação de Carteira. Um componente só para os três
 * lugares não divergirem: é o mesmo estado sendo comunicado.
 *
 * Dois casos distintos, porque a saída é diferente:
 *  - sem contato nenhum (o normal em carteira recém-importada): falta
 *    vincular ou cadastrar o contato;
 *  - contato existe mas sem telefone real (criado pela conciliação sem
 *    número): falta completar o telefone.
 */
const NoContactChip = ({ hasContact, className }) => {
  const classes = useStyles();

  const label = hasContact ? "sem WhatsApp" : "não conciliado";
  const title = hasContact
    ? "Contato criado sem telefone real — complete o número para poder conversar"
    : "Apólice ainda sem contato vinculado — sem isso não há com quem conversar no WhatsApp";

  return (
    <Tooltip title={title}>
      <Chip
        size="small"
        icon={<LinkOffIcon className={classes.icon} />}
        label={label}
        variant="outlined"
        className={className ? `${classes.chip} ${className}` : classes.chip}
      />
    </Tooltip>
  );
};

export default NoContactChip;
